import {Box, Grid, Table, TableBody, TableCell, TableHead, TableRow, Typography} from "@mui/material";
import {numberWithPoints} from "../../../../utils/numberWithPoints";
import {normalizeTimestemp} from "../../../../utils/normalizeTimestemp";
import React, {useEffect, useState} from "react";
import "./SimulationData.css"
import axios from "axios";
import {ApiUrl} from "../../../../auth/authMethods";
import {useUser} from "../../../../auth/AuthProvider";

export default function SimulationData({previewData}) {

    const {user} = useUser()
    const [compradorName, setCompradorName] = useState()
    const [vendedorName, setVendedorName] = useState()
    const [fundoName, setFundoName] = useState()

console.log({previewData})
    return <>


        <Box sx={{bgcolor: 'black', color: 'white', textAlign: 'center', mt: 3, mb: 1}}>
            <Typography variant="h6" gutterBottom>
                Parcelas
            </Typography>
        </Box>
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Table size="small" aria-label="table with impares background" className={'simulation-table'}>
                    <TableHead>
                        <TableRow>
                            <TableCell>Parcela</TableCell>
                            <TableCell>Vencimento</TableCell>
                            <TableCell>Valor Parcela</TableCell>
                            <TableCell>Valor Repasse</TableCell>
                            <TableCell>Prazo</TableCell>
                            <TableCell>Fator Desconto</TableCell>
                            <TableCell>Valor Presente</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {previewData.parcelas?.map((parcela, idx) => (
                            <TableRow key={idx} className={idx % 2 === 0 ? 'odd-row' : 'even-row'}>
                                <TableCell>{parcela.numero}</TableCell>
                                <TableCell>{normalizeTimestemp(parcela.vencimento)}</TableCell>
                                <TableCell>R$ {numberWithPoints(parcela.valorParcela)}</TableCell>
                                <TableCell>R$ {numberWithPoints(parcela.valorRepasse)}</TableCell>
                                <TableCell>{parcela.prazo}</TableCell>
                                <TableCell>{parcela.fatorDesconto}</TableCell>
                                <TableCell>R$ {numberWithPoints(parcela.valorPresente)}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </Grid>

        </Grid>

        <Box sx={{bgcolor: 'black', color: 'white', textAlign: 'center', mt: 1, mb: 1}}>
            <Typography variant="h6" gutterBottom>
                Totais
            </Typography>
        </Box>
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Table size="small" aria-label="table with impares background" className={'simulation-table'}>
                    <TableHead>
                        <TableRow>
                            <TableCell>Valor Liquido</TableCell>
                            <TableCell>Valor Presente</TableCell>
                            <TableCell>Valor Desconto</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow className={'odd-row'}>
                            <TableCell>R$ {numberWithPoints(previewData.valorLiquido)}</TableCell>
                            <TableCell>R$ {numberWithPoints(previewData.valorPresente)}</TableCell>
                            <TableCell>R$ {numberWithPoints(previewData.valorDesconto)}</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </Grid>

        </Grid>

        <Box sx={{bgcolor: 'black', color: 'white', textAlign: 'center', mt: 1, mb: 1}}>
            <Typography variant="h6" gutterBottom>
                Participantes
            </Typography>
        </Box>
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Table size="small" aria-label="table with impares background" className={'simulation-table'}>
                    <TableHead>
                        <TableRow>
                            <TableCell>Fundo</TableCell>
                            <TableCell>Vendedor(es)</TableCell>
                            <TableCell>Comprador(es)</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {(() => {
                            const fundos = previewData.users.filter(item => item.papel === "FUNDO");
                            const vendedores = previewData.users.filter(item => item.papel === "VENDEDOR");
                            const compradores = previewData.users.filter(item => item.papel === "COMPRADOR");

                            // Descobre a quantidade máxima de linhas necessária
                            const maxRows = Math.max(fundos.length, vendedores.length, compradores.length) || 1;

                            return Array.from({ length: maxRows }).map((_, index) => (
                                <TableRow key={index}>
                                    <TableCell>{fundos[index]?.nome || ""}</TableCell>
                                    <TableCell>{vendedores[index]?.nome || ""}</TableCell>
                                    <TableCell>{compradores[index]?.nome || ""}</TableCell>
                                </TableRow>
                            ));
                        })()}
                    </TableBody>
                </Table>
            </Grid>

        </Grid>
    </>
}